import { some } from 'lodash';
import { TraceEvents } from '../call-trace-event';
export function selectIsParticipantLeft(events, person) {
    return some(events, (e) => e.name === TraceEvents.PnPersonLeft && e.data.person === person);
}
